module.exports = __webpack_public_path__ + "static/media/MLS.646f6966.jpg";